<template>
    <div class=counter>
        <div class="calc"> 
            <div class="addsub">
                <button type="button" class="_sub" @click="decrease">
                    <span class="blind">수량 빼기</span>
                </button>
                <input type="text" class="_counter"  v-model.trim="count" @keypress="ckCounter($event)" readonly>
                <button type="button" class="_add" @click="increase">
                    <span class="blind">수량 추가</span>
                </button>
            </div>
        </div>
        <div class="max_count"><div class="cont">사용 가능 갯수 <span>{{max}}</span></div></div>
    </div>
</template>
<script>
export default {
    props:['max'],
    data()
    {
        return{
            count:1,
        }
    },
    methods:{
        ckCounter(evt){
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        increase(){
            if((this.count +1) > this.max)
            {
                alert('사용가능 갯수보다 많습니다.');
                return;
            }
            this.count++;
            this.emitCount();
        },
        decrease(){
            if(this.count === 1)
            {
                alert('최소단위는 1개입니다.');
                return;
            }
            this.count--;
            this.emitCount();
        },
        emitCount()
        {
            this.$emit("getcount", this.count);    
        }
    }
       
}
</script>
<style lang="scss" scoped>
.counter{
    padding:20px 0;
   
    .calc{
        display:flex;
        justify-content: center;  
        .addsub{
            display:inline-block;
            border:solid 1px #dde0e3;
            vertical-align:top;
            height: 34px;
            ._add,._sub{
                border: none;
                cursor: pointer;
                position: relative;
                width: 34px;
                height: 100%;
                background-color: #f1f2f4;
            }
            ._sub:before{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 11px;
                height: 1px;
                margin: -1px 0 0 -6px;
                background-color: #555555;
                content: '';
            }
            ._add:before{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 11px;
                height: 1px;
                margin: -1px 0 0 -6px;
                background-color: #555555;
                content: '';
            }
            ._add:after{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 1px;
                height: 11px;
                margin: -6px 0 0 -1px;
                background-color: #555555;
                content: '';
            }
            ._counter{
                width: 44px;
                height: 100%;
                border: solid #eff1f5;
                border-width: 0 1px;
                vertical-align: top;
                color: #333333;
                font-size: 12px;
                font-weight: bold;
                line-height: 34px;
                text-align: center;
            }
        }
    }
    .max_count{        
        display:flex;
        justify-content: center;       
        .cont{
            width:114px; 
            padding:3px 0;
            text-align:center;
            background:#000;
            color:#fff;
        }
    }
   
}
</style>